import React, {useState} from 'react';
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";

import css from './MealComponent.module.css';
import {ButtonDelete, ButtonUpdate, ModalForDelete} from "../../../ui";
import {mealsService} from "../../../services/settings-services";
import {mealsActions} from "../../../store/slices/settings-slices";
import MealUpdateModal from '../settingSectionModals/MealUpdateModal/MealUpdateModal';


const MealComponent = (props) => {
    const dispatch = useDispatch();
    const {i18n} = useTranslation();
    const [isOpenUpdate, setIsOpenUpdate] = useState(false);
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
    const {meal: {id, name}} = props;

    const currentLanguage = i18n.language;
    const displayName = name[currentLanguage] || name["en"];


    const handleDeleteClick = async () => {
        try {
            await mealsService.deleteById(id);
            dispatch(mealsActions.changeTrigger());
            toast.success('meal is deleting!');
        } catch (error) {
            console.error("Error deleting meal:", error);
        }
    };


    const handleUpdateClick = () => {
        setIsOpenUpdate(true);
    };


    return (
        <section className={css.wrap}>
            <section className={css.title}>{displayName}</section>

            <section className={css.blockButton}>
                <ButtonUpdate onClick={handleUpdateClick}/>
                <ButtonDelete onClick={() => setIsOpenDeleteModal(true)}/>
            </section>

            {isOpenUpdate && <MealUpdateModal
                setIsOpenUpdate={setIsOpenUpdate}
                meal={props.meal}
            />}


            {isOpenDeleteModal && <ModalForDelete
                handleDeleteClick={handleDeleteClick}
                setIsOpenDeleteModal={setIsOpenDeleteModal}
                name={'meal'}
            />}
        </section>
    );
};

export {MealComponent};